/**
 * Progress Bar module
 */
var ProgressBar = function(container, options) {

    var _defaults = {
        steps: 2,
        current: 1,
        color: '#0099e8'
    };
    this.options = $.extend({}, _defaults, options || {});
    this._current = this.options.current;
    this._total = this.options.steps;
    this._container = typeof container === 'string' ? $(container) : container;
    this._init();
    return this;
};

ProgressBar.prototype._init = function() {
    this._bar = $('<div>').addClass('progress-bar').css('background-color', this.options.color).css('width', '0%');
    this._container.addClass('progress-bar-container').append(this._bar);
    var self = this;
    setTimeout(function(){
        self.step(self._current);
    }, 1000);
}

ProgressBar.prototype.step = function(step) {
    var segment = 100 / this._total;
    this._current = step;
    this._bar.css('width', (segment * this._current) + '%');
}

ProgressBar.prototype.nextStep = function() {
    this._current++;
    if (this._current > this._total) {
        this._current--;
        return;
    }
    this.step(this._current);
}

ProgressBar.prototype.prevStep = function() {
    this._current--;
    if (this._current < 0) {
        this._current++;
        return;
    }
    this.step(this._current);
}

ProgressBar.prototype.hide = function() {
    this._bar.css('height', '0px');
}

ProgressBar.prototype.show = function() {
    this._bar.css('height', '100%');
}

ProgressBar.prototype.destroy = function() {
    this._container.removeClass('progress-bar-container');
    this._container.empty();
}

export default ProgressBar;
